import { CartSubmit } from '@ui/cart';

export const CheckoutFooter = ({ onPress }: { onPress?: () => void }) => {
  return (
    <div
      className={`drop-shadow-[0_0_12px_#34578C26] h-20 p-4 bg-white fixed bottom-0 left-0 right-0 z-30 flex flex-col gap-6`}
    >
      <CartSubmit variant="checkout" onPress={onPress} />
    </div>
  );
};
